import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MotivoCancelamento } from '../motivo-cancelamento';
import { MotivoCancelamentoService } from '../motivo-cancelamento.service';

@Component({
  selector: 'app-motivo-cancelamento-maintenance',
  templateUrl: './motivo-cancelamento-maintenance.component.html',
  styleUrls: ['./motivo-cancelamento-maintenance.component.css']
})
export class MotivoCancelamentoMaintenanceComponent implements OnInit {

  isUpdate: string;

  isInfo: boolean = false;

  motivoCancelamento: MotivoCancelamento;

  formularioMotivoCancelamento: FormGroup;

  tituloCrud: string = '';

  constructor(private motivoCancelamentoService: MotivoCancelamentoService,
    private route: ActivatedRoute, private router: Router,
    private formBuilder: FormBuilder) {

    this.isUpdate = history.state.isUpdate;

    this.motivoCancelamento = history.state.entity;

    this.formularioMotivoCancelamento = this.formBuilder.group({
      id: 0,
      descricao: ['', [Validators.required, Validators.minLength(3)]]
    });
  }

  ngOnInit() {
    if (this.motivoCancelamento) {
      if (this.isUpdate == 'S') {
        this.tituloCrud = 'Alterar Motivo Cancelamento';
      } else {
        this.isInfo = true;
        this.tituloCrud = 'Detalhe Motivo Cancelamento';
      }
    } else {
      this.tituloCrud = 'Criar Motivo Cancelamento';

      this.motivoCancelamento = new MotivoCancelamento();
    }

    if (!this.isNew()) {
      this.formularioMotivoCancelamento.setValue(this.motivoCancelamento);

      if (this.isUpdate == 'N') {
        this.formularioMotivoCancelamento.disable();
      }
    } else {
      this.formularioMotivoCancelamento.setValue({
        id: 0,
        descricao: ''
      });
    }
  }

  save() {

    this.motivoCancelamento = this.formularioMotivoCancelamento.value;

    if (this.isNew()) {
      this.motivoCancelamentoService
        .criar(this.motivoCancelamento).subscribe(data => {
          // console.log(data)

          this.gotoList();
        }, error => {
          console.log(error);
        });
    } else {
      this.motivoCancelamentoService.atualizar(this.motivoCancelamento, this.motivoCancelamento.id)
        .subscribe(data => {
          // console.log(data);

          this.gotoList();
        }, error => {
          console.log(error);
        });
    }
  }

  onSubmit() {
    this.save();
  }

  gotoList() {
    this.router.navigate(['/motivoCancelamento']);
  }

  isNew(): boolean {
    return !this.motivoCancelamento || !this.motivoCancelamento.id;
  }

}
